"use client"
import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import Popups, { PopupsRef } from "."
import { useEffect, useRef } from "react"

const PopupContainer = ({ page }: { page: TypeStoreDetail['popups'][0]['event']['page'] }) => {
  const refPopups = useRef<PopupsRef>(null)
  
  useEffect(() => {
    refPopups.current?.open(page)
  }, [page])

  return (
    <Popups ref={refPopups} />
  )
}

export default PopupContainer